// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn3d {
  transition: all 0.08s linear;
  position: relative;
  outline: medium none;
  -moz-outline-style: none;
  border: 0px;
  margin-right: 10px;
  margin-top: 15px;
}
.btn3d:focus {
  outline: medium none;
  -moz-outline-style: none;
}
.btn3d:active {
  top: 9px;
}

.btn3d-default-light {
  margin-top: 25px;
  box-shadow: 0 0 0 0px #ebebeb inset, 0 0 0 0px rgba(255, 255, 255, 0.15) inset,
    0 1px 0 1px #adadad, 0 0px 0 0px rgba(0, 0, 0, 0.4),
    0 1px 1px 1px rgba(0, 0, 0, 0.7);
  background-color: #fff;
}

.btn3d-default {
  margin-top: 15px;
  box-shadow: 0 0 0 1px #ebebeb inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 1px 0 0 #adadad, 0 1px 0 1px rgba(0, 0, 0, 0.4),
    0 1px 1px 1px rgba(0, 0, 0, 0.5);
  background-color: #fff;
}
.btn3d-default-custom {
  margin-top: 15px;
  box-shadow: 0 0 0 1px #ebebeb inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 2px 0 0 #adadad, 0 1px 0 1px rgba(0, 0, 0, 0.4),
    0 2px 2px 2px rgba(0, 0, 0, 0.5);
  background-color: #fff;
}

.btn3d-primary {
  box-shadow: 0 0 0 1px #428bca inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #357ebd, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #428bca;
}
.btn3d-success {
  box-shadow: 0 0 0 1px #5cb85c inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #4cae4c, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #5cb85c;
}
.btn3d-info {
  box-shadow: 0 0 0 1px #5bc0de inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #46b8da, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #5bc0de;
}
.btn3d-warning {
  box-shadow: 0 0 0 1px #f0ad4e inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #eea236, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #f0ad4e;
}
.btn3d-danger {
  box-shadow: 0 0 0 1px #c63702 inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #c24032, 0 8px 0 1px rgba(0, 0, 0, 0.4),
    0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #c63702;
}
`, "",{"version":3,"sources":["webpack://./src/Components/CSS/3d.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB;;oCAEkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB;;oCAEkC;EAClC,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB;;oCAEkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;;oCAEkC;EAClC,yBAAyB;AAC3B;AACA;EACE;;oCAEkC;EAClC,yBAAyB;AAC3B;AACA;EACE;;oCAEkC;EAClC,yBAAyB;AAC3B;AACA;EACE;;oCAEkC;EAClC,yBAAyB;AAC3B;AACA;EACE;;oCAEkC;EAClC,yBAAyB;AAC3B","sourcesContent":[".btn3d {\r\n  transition: all 0.08s linear;\r\n  position: relative;\r\n  outline: medium none;\r\n  -moz-outline-style: none;\r\n  border: 0px;\r\n  margin-right: 10px;\r\n  margin-top: 15px;\r\n}\r\n.btn3d:focus {\r\n  outline: medium none;\r\n  -moz-outline-style: none;\r\n}\r\n.btn3d:active {\r\n  top: 9px;\r\n}\r\n\r\n.btn3d-default-light {\r\n  margin-top: 25px;\r\n  box-shadow: 0 0 0 0px #ebebeb inset, 0 0 0 0px rgba(255, 255, 255, 0.15) inset,\r\n    0 1px 0 1px #adadad, 0 0px 0 0px rgba(0, 0, 0, 0.4),\r\n    0 1px 1px 1px rgba(0, 0, 0, 0.7);\r\n  background-color: #fff;\r\n}\r\n\r\n.btn3d-default {\r\n  margin-top: 15px;\r\n  box-shadow: 0 0 0 1px #ebebeb inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,\r\n    0 1px 0 0 #adadad, 0 1px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 1px 1px 1px rgba(0, 0, 0, 0.5);\r\n  background-color: #fff;\r\n}\r\n.btn3d-default-custom {\r\n  margin-top: 15px;\r\n  box-shadow: 0 0 0 1px #ebebeb inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,\r\n    0 2px 0 0 #adadad, 0 1px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 2px 2px 2px rgba(0, 0, 0, 0.5);\r\n  background-color: #fff;\r\n}\r\n\r\n.btn3d-primary {\r\n  box-shadow: 0 0 0 1px #428bca inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,\r\n    0 8px 0 0 #357ebd, 0 8px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 8px 8px 1px rgba(0, 0, 0, 0.5);\r\n  background-color: #428bca;\r\n}\r\n.btn3d-success {\r\n  box-shadow: 0 0 0 1px #5cb85c inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,\r\n    0 8px 0 0 #4cae4c, 0 8px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 8px 8px 1px rgba(0, 0, 0, 0.5);\r\n  background-color: #5cb85c;\r\n}\r\n.btn3d-info {\r\n  box-shadow: 0 0 0 1px #5bc0de inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,\r\n    0 8px 0 0 #46b8da, 0 8px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 8px 8px 1px rgba(0, 0, 0, 0.5);\r\n  background-color: #5bc0de;\r\n}\r\n.btn3d-warning {\r\n  box-shadow: 0 0 0 1px #f0ad4e inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,\r\n    0 8px 0 0 #eea236, 0 8px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 8px 8px 1px rgba(0, 0, 0, 0.5);\r\n  background-color: #f0ad4e;\r\n}\r\n.btn3d-danger {\r\n  box-shadow: 0 0 0 1px #c63702 inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,\r\n    0 8px 0 0 #c24032, 0 8px 0 1px rgba(0, 0, 0, 0.4),\r\n    0 8px 8px 1px rgba(0, 0, 0, 0.5);\r\n  background-color: #c63702;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
